import React from "react";

const ClaimSortSkeleton: React.FC = () => (
  <div className="overflow-y-scroll hide-scrollbar3 h-[calc(100vh_-_166px)] bg-[#fff]">
    {[...Array(2)].map((_, patentIdx) => (
      <div className="mb-2 last:mb-0 bg-white px-3 pb-2" key={patentIdx}>
        <div className="py-3">
          <div className="pb-2">
            <div className="h-5 w-32 bg-gray-200 rounded mb-1 animate-pulse"></div>
          </div>
          <div className="flex items-center gap-x-4">
            <div className="h-4 w-40 bg-gray-200 rounded animate-pulse"></div>
          </div>
        </div>
        {[...Array(3)].map((_, claimIdx) => (
          <div key={claimIdx} className="mb-3 last:mb-2 accordion-hide">
            <div className="border border-[#CCE0FF] px-5 py-5 bg-[#FDFDFD] flex items-center justify-between animate-pulse">
              <div className="flex items-center gap-x-3">
                <div className="h-5 w-20 bg-gray-200 rounded"></div>
                <div className="px-1.5 py-0.5 rounded-md bg-green-200 w-16 h-5"></div>
              </div>
              <div className="flex items-center gap-x-3.5">
                <div className="w-32 h-6 bg-gray-200 rounded-sm"></div>
                <div className="w-6 h-6 bg-gray-200 rounded-md"></div>
              </div>
            </div>
          </div>
        ))}
      </div>
    ))}
  </div>
);

export default ClaimSortSkeleton;